import styled, { css } from 'styled-components';
import { isMobileStyleMixin } from '@amzn/storm-ui';

const smallScreen = '@media (max-width: 576px)';
const adaptiveHelpTipWidth = '19px';
const labelMargin = '2px';
const FormRowDiv = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-storm-ui-30075772__sc-udgczc-0"
})(["margin:0 0 ", " 0;display:flex;flex-direction:row;justify-content:start;width:100%;", "{flex-direction:column;}", ""], ({
  theme
}) => theme.spacing.base, smallScreen, isMobileStyleMixin(css(["flex-direction:column;"])));
const LeftColumn = /*#__PURE__*/styled('div').withConfig({
  componentId: "sc-storm-ui-30075772__sc-udgczc-1"
})(["position:relative;top:", ";flex:0 0 33.33%;display:flex;justify-content:flex-end;text-align:end;max-width:167px;", "{top:0px;max-width:100%;justify-content:flex-start;text-align:start;}", ""], ({
  $topSpacing
}) => $topSpacing, smallScreen, isMobileStyleMixin(css(["top:0px;max-width:100%;justify-content:flex-start;text-align:start;"])));
const RightColumn = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-storm-ui-30075772__sc-udgczc-2"
})(["flex:1 1 100%;margin-inline-start:", ";margin-inline-end:", ";", "{margin-inline-start:0;}", ""], ({
  theme
}) => theme.spacing.small, ({
  theme
}) => theme.spacing.xlarge, smallScreen, isMobileStyleMixin(css(["margin-inline-start:0;"])));
const ControlComponent = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-storm-ui-30075772__sc-udgczc-3"
})([":not(:last-of-type){margin-bottom:", ";}label,label&,legend,legend&{font-weight:400;}", ""], ({
  theme
}) => theme.spacing.base, isMobileStyleMixin(css(["label,label&&,legend,legend&&{margin-bottom:1px;padding-bottom:0px;font-weight:400;}"])));
const LabelContainer = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-storm-ui-30075772__sc-udgczc-4"
})(["display:flex;flex-direction:column;margin-inline-end:", ";margin-inline-start:0;", ";", ""], labelMargin, ({
  theme
}) => theme.typography.base, isMobileStyleMixin(css(["", ";"], ({
  theme
}) => theme.typography.mobile.base)));
const HelpTipPlaceholder = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-storm-ui-30075772__sc-udgczc-5"
})(["padding:9.5px;"]);
const Label = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-storm-ui-30075772__sc-udgczc-6"
})(["display:flex;justify-content:flex-end;", "{justify-content:flex-start;label,label&{margin-bottom:", ";}}", ""], smallScreen, labelMargin, isMobileStyleMixin(css(["justify-content:flex-start;label,label&{margin-bottom:", ";}"], labelMargin)));
const OptionalTag = /*#__PURE__*/styled('label').withConfig({
  componentId: "sc-storm-ui-30075772__sc-udgczc-7"
})(["font-size:12px;line-height:18px;color:", ";margin-inline-end:", ";margin-inline-start:0;label,label&,legend,legend&{font-weight:400;padding-inline-start:0;}", "{margin-inline-end:0px;margin-inline-start:0px;}", ""], ({
  theme
}) => theme.palette.boulder, adaptiveHelpTipWidth, smallScreen, isMobileStyleMixin(css(["margin-inline-end:0px;margin-inline-start:0px;"])));

/*  Offset the default padding in AdaptiveHelpTip on mobile */
const AdaptiveHelpTipContainer = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-storm-ui-30075772__sc-udgczc-8"
})(["", ""], isMobileStyleMixin(css(["button{padding:0 7px;transform:translateY(-2px);}"])));

export { AdaptiveHelpTipContainer as A, ControlComponent as C, FormRowDiv as F, HelpTipPlaceholder as H, LeftColumn as L, OptionalTag as O, RightColumn as R, LabelContainer as a, Label as b };
//# sourceMappingURL=FormRow.styles-BWYpHH28.js.map
